module.exports = __webpack_public_path__ + "img/CRT_Weapon-Fan-01.5c312662.png";